import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Link from "@mui/material/Link";
import oluseun from "../../../assets/advisory/oluseun.jpg";
import iyadunni from "../../../assets/advisory/iyadunni.jpg";
import adebayo from "../../../assets/advisory/adebayo.jpg";

const data = [
  {
    imgpath: iyadunni,
    name: "Iyadunni Olubode",
    title: "Advisor",
    profile:
      "Iyadunni Olubode has over fifteen (15) years’ experience consulting with a global firm and managing one of the biggest non-profit organizations in Nigeria and started her career in commercial bank and subsequently moved to management.",
    link: "/advisory-council/iyadunni-olubode",
  },
  {
    imgpath: adebayo,
    name: "Tope Adebayo",
    title: "Law Consultant",
    profile:
      "Tope is an alumnus of the Prestigious Harvard Kennedy School of Executive Education (Leaders in Development: Managing Change in a Dynamic World), He is an Attorney with vast experience in Dispute Resolution.",
    link: "/advisory-council/tope-adebayo",
  },

  {
    imgpath: oluseun,
    name: "Oluseun Onigbinde",
    title: "Advisor",
    profile:
      "Oluseun Onigbinde, a graduate of Engineering from the University of Agriculture, Abeokuta, Nigeria, co-founded Nigeria’s civic tech organization, BudgIT in 2011. BudgIT uses technologies of any form that appeal across every literacy span.",
    link: "/advisory-council/oluseun-onigbinde",
  },
];

const Details = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "5% 0%" }}>
      <Typography
        variant={"h3"}
        fontWeight={900}
        textAlign={"left"}
        color={"#00AEEF"}
        paddingBottom={"1%"}
      >
        <Typography
          component={"span"}
          variant={"h3"}
          color="#3E4095"
          fontWeight={900}
        >
          Our {""}
        </Typography>
        Advisory Council
      </Typography>
      <Typography
        variant={"body1"}
        fontWeight={400}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"2%"}
      >
        Our Advisory Council consist of seasoned experts in fields that are
        essential to what we do. We turn to these set of visionaries for advice
        and tutelage.
      </Typography>
      <Grid container spacing={1}>
        {data.map((list, index) => {
          const { imgpath, name, link, title, profile } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                marginTop={{ xs: "10%", sm: "3%" }}
                key={index}
              >
                <Card sx={{ maxWidth: 360, height: "100%" }}>
                  <CardActionArea href={link}>
                    <CardMedia
                      component="img"
                      height="340"
                      image={imgpath}
                      sx={{ objectFit: "cover" }}
                      alt={name}
                    />
                    <CardContent>
                      <Typography
                        gutterBottom
                        variant="h5"
                        color={"#3E4095"}
                        component="div"
                        fontWeight={700}
                        paddingBottom={"1%"}
                      >
                        {name}
                      </Typography>
                      <Typography
                        paddingBottom={"2%"}
                        variant="body2"
                        color="#00AEEF"
                        fontWeight={700}
                        data-aos={"fade-up"}
                      >
                        {title}
                      </Typography>
                      <Typography
                        paddingBottom={"5%"}
                        variant="body1"
                        color="text.secondary"
                        data-aos={"fade-up"}
                      >
                        {profile}
                      </Typography>
                      <Box
                        marginLeft={{ xs: " 0%", sm: "0%" }}
                        paddingTop={"2%"}
                      >
                        <Link
                          underline="none"
                          component="a"
                          href={link}
                          textAlign={"left"}
                          color="#00AEEF"
                          fontWeight={700}
                          sx={{
                            "&:hover": {
                              color: "#3E4095",
                            },
                          }}
                        >
                          Read More &#10140;
                        </Link>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Details;
